import { For, Show } from "solid-js"
import { Dynamic } from "solid-js/web"
import { ValidationMissing, ValidationSuccess, ValidationWarning } from "./ValidationIndicators"

export const ValidationBar = (props) => {

  const { EMPTY, VALID, INVALID } = MEAS_VALIDATION_STATUS;
  const validationElements = {
    [EMPTY]: ValidationMissing,
    [VALID]: ValidationSuccess,
    [INVALID]: ValidationWarning
  }
  const pluralize = (count, noun, suffix = 's') => `${noun}${count !== 1 ? suffix : ''}`;

  const validationData = () => props.validationData;



  const validCount = () => validationData().reduce((prevVal, currVal, ind) => {
    if (currVal == VALID) {
      return prevVal + 1
    }
    return prevVal;
  }, 0)

  return (
    <div
      class={`flex justify-start  ${props.inline ? "flex-col items-start " : "flex-row items-center sm:pl-2 grow lg:grow-0"} gap-1 ${props.className != undefined ? props.className : ''}`}
      classList={{
        "themed-scrollbar lg:notouch:scrollbar-hide": validationData().length > 6
      }}
      style={`${props.style != undefined ? props.style : ''}`}>
      <div class="flex items-center" style="gap: 0px;">

        <Show when={!props.inline}>
          <div class={` mx-[2px] flex flex-col gap-1 lg:rounded-full lg:gap-0 cursor-pointer ${props.formDisplayCursor() === 0 ? 'bg-canvas-lighter' : ''}`} onclick={() => { props.handleCursorChange(0); }}>
            <div class="w-4 h-4 mt-1 lg:mt-0  flex items-center justify-center hover:scale-110 font-mono">

              <svg class="border border-frame text-ink fill-current rounded-full" width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M17.776 12.096c-.3627 0-.6533-.0987-.872-.296-.2187-.2027-.328-.4693-.328-.8 0-.3467.1387-.6507.416-.912.2827-.26668.608-.40001.976-.40001.3413 0 .632.104.872.312.2453.20801.368.45871.368.75201 0 .224-.0693.44-.208.648-.1387.2027-.3173.3707-.536.504-.2133.128-.4427.192-.688.192Zm-3.568 10.216c-.448 0-.7973-.0987-1.048-.296-.2453-.1973-.368-.4667-.368-.808 0-.144.024-.3253.072-.544.048-.2187.1227-.4347.224-.648l2.464-5.16c.0373-.0747.0587-.1333.064-.176.0053-.048.008-.088.008-.12 0-.1067-.064-.16-.192-.16-.1813 0-.4107.0933-.688.28-.272.1813-.5307.4187-.776.712l-.424-.336c.896-.976 1.848-1.464 2.856-1.464.4747 0 .84.0987 1.096.296.2613.1973.392.4693.392.816 0 .1387-.024.3173-.072.536-.048.2133-.1227.4293-.224.648l-2.44 5.088c-.0373.0693-.0587.12-.064.152-.0053.032-.008.0613-.008.088 0 .1333.0773.2.232.2.1707 0 .392-.1067.664-.32.2773-.2133.6773-.592 1.2-1.136l.44.264c-.6133.72-1.192 1.248-1.736 1.584-.544.336-1.1013.504-1.672.504Z" />
              </svg>



            </div>
            <div class={`lg:hidden w-full border-t-4 ${props.formDisplayCursor() > 0 ? 'border-transparent' : 'border-secondary-accent'}`}
            ></div>
          </div>

        </Show>

        <For each={validationData()}>
          {(data, index) => {
            const isCurrent = () => props.inline ? false : props.formDisplayCursor() === index() + 1;
            return (<div onclick={() => { if (!props.inline) { props.handleCursorChange(index() + 1); } }}
              class={`flex flex-col gap-1 lg:p-[2px] lg:gap-0 lg:rounded-full ${isCurrent() ? 'bg-canvas-lighter' : ''}`}>

              <Dynamic
                component={validationElements[data]} index={index} className={`${props.inline ? `h-4 w-4 mx-[2px] ${isCurrent() ? 'border-solid' : ''}` : `h-4 w-4 hover:scale-110 mx-[2px] mt-1 lg:mt-0 cursor-pointer ${isCurrent() ? 'border-solid' : ''}`}`} />
              <Show when={!props.inline}>

                <div class={` lg:hidden w-full border-t-4`}
                  classList={{
                    'border-secondary-accent': props.formDisplayCursor() === index() + 1,
                    'border-transparent': props.formDisplayCursor() > index() + 1 || props.formDisplayCursor() < index() + 1,
                  }}
                ></div>
              </Show>

            </div>)
          }}
        </For>
        <Show when={!props.inline}>
          <div class={`flex flex-col gap-1 lg:rounded-full group cursor-pointer ${props.formDisplayCursor() + 1 == props.formDisplaySequence().length ? 'bg-canvas-lighter' : ''}`} onclick={() => { props.handleCursorChange(props.formDisplaySequence().length - 1); }}>
            <div class={`w-4 h-4 mt-1 lg:mt-0 hover:scale-110 `}>
              <svg fill="none" viewBox="0 0 64 64"><path fill="currentColor" fill-rule="evenodd" d="M14.67 13.8726h-1.2469v37.6528H14.67V13.8726Zm-2.2202-.9733v39.5994h3.1935V12.8993h-3.1935Zm37.3487.9733H18.0004v18.9253h31.7981V13.8726Zm-32.7713-.9733v20.8718h33.7446V12.8993H17.0272Z" clip-rule="evenodd" /><path fill="currentColor" d="M18.4428 14.1575h5.7625V19.92h-5.7625v-5.7625Zm12.5754 0h5.7625V19.92h-5.7625v-5.7625Zm12.5754 0h5.7625V19.92h-5.7625v-5.7625Zm-6.2877 6.1854h5.7625v5.7625h-5.7625v-5.7625Zm-12.5754 0h5.7625v5.7625h-5.7625v-5.7625Zm-6.2877 6.1859h5.7625v5.7625h-5.7625v-5.7625Zm12.5754 0h5.7625v5.7625h-5.7625v-5.7625Zm12.5754 0h5.7625v5.7625h-5.7625v-5.7625Z" /></svg>
            </div>
            <div class={`lg:hidden w-full border-t-4 ${props.formDisplayCursor() + 1 == props.formDisplaySequence().length ? 'border-secondary-accent bg-canvas-depressed' : 'border-transparent'}`}
            ></div>
          </div>
        </Show>


      </div>
      <Show when={props.inline}>
        <div class={`font-bold flex leading-none ${props.inline ? 'flex-row gap-1 items-center' : 'flex-col'}`}>
          <div>{validCount()}/{validationData().length}</div>
          <div>{`${props.inline ? pluralize(validCount(), "Measurement") : ""}`} Complete</div>
        </div>
      </Show>


    </div>
  )
}

export const ValidationStatus = (props) => {
  const { VALID } = MEAS_VALIDATION_STATUS;

  const pluralize = (count, noun, suffix = 's') => `${noun}${count !== 1 ? suffix : ''}`;

  const validationData = () => props.validationData;

  const validCount = () => validationData().reduce((prevVal, currVal, ind) => {
    if (currVal == VALID) {
      return prevVal + 1
    }
    return prevVal;
  }, 0)

  return (
    <div class={`font-bold flex leading-none flex-row gap-1 items-start`}>
      <div>{validCount()}/{validationData().length}</div>
      <div>{`${pluralize(validCount(), "Measurement")}`} Complete</div>
    </div>
  )
}